<template>
    <div class="form form__hours">
        <table>
            <tr
                v-for="(item, index) in hours"
                :key="index"
            >
                <td>
                    <div class="columns is-gapless is-vcentered">
                        <div class="column is-narrow">
                            <label
                                :for="`form-hours-${days[index]}`"
                            >
                                <input
                                    type="checkbox"
                                    :name="name | toKebabCase"
                                    :checked="item.workFromLocal && item.workToLocal"
                                    :id="`form-hours-${days[index]}`"
                                    @click="toggleDay(index)"
                                >
                                <span></span>
                            </label>
                        </div>
                        <div class="column">
                            <div class="form__hours_day">{{days[index] | toCapitalize}}</div>
                        </div>
                    </div>
                </td>
                <td>
                    <template v-if="item.workFrom && item.workTo">
                        <div class="columns column--customflex has-text-right is-vcentered is-variable is-1">
                            <div class="column"></div>
                            <div class="column column--customflexhour is-narrow">
                                <select
                                    :name="`${days[index]}-start-hour`"
                                    :value="timeHour(item.workFromLocal)"
                                    @input="updateWorkFrom($event.target.value, timeMinute(item.workFromLocal), index)"
                                >
                                    <option
                                        v-for="(item, index) in 24"
                                        :key="index"
                                        :value="timeFormat(index)"
                                    >{{ timeFormat(index) }}
                                    </option>
                                </select>
                            </div>
                            <div class="column column--customflexhour is-narrow">
                                <select
                                    :name="`${days[index]}-start-minute`"
                                    :value="timeMinute(item.workFromLocal)"
                                    @input="updateWorkFrom(timeHour(item.workFromLocal), $event.target.value,index)"
                                >
                                    <option
                                        v-for="(item, index) in 60"
                                        :key="index"
                                        :value="timeFormat(index)"
                                    >{{ timeFormat(index) }}
                                    </option>
                                </select>
                            </div>
                            <div class="column column--customflexbreak is-narrow">-</div>
                            <div class="column column--customflexhour is-narrow">
                                <select
                                    :name="`${days[index]}-end-hour`"
                                    :value="timeHour(item.workToLocal)"
                                    @input="updateWorkTo($event.target.value, timeMinute(item.workToLocal), index)"
                                >
                                    <option
                                        v-for="(item, index) in 24"
                                        :key="index"
                                        :value="timeFormat(index)"
                                    >{{ timeFormat(index) }}
                                    </option>
                                </select>
                            </div>
                            <div class="column column--customflexhour is-narrow">
                                <select
                                    :name="`${days[index]}-end-minute`"
                                    :value="timeMinute(item.workToLocal)"
                                    @input="updateWorkTo(timeHour(item.workToLocal), $event.target.value,index)"
                                >
                                    <option
                                        v-for="(item, index) in 60"
                                        :key="index"
                                        :value="timeFormat(index)"
                                    >{{ timeFormat(index) }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="columns is-variable">
                            <div class="column has-text-right">
                                <span
                                    class="form__error form__text_error"
                                    v-if="errors.first(`${days[index]}-start-hour`)"
                                >{{ errors.first(`${days[index]}-start-hour`) }}</span>
                                <span
                                    class="form__error form__text_error"
                                    v-if="errors.first(`${days[index]}-start-minute`)"
                                >{{ errors.first(`${days[index]}-start-minute`) }}</span>
                                <span
                                    class="form__error form__text_error"
                                    v-if="errors.first(`${days[index]}-end-hour`)"
                                >{{ errors.first(`${days[index]}-end-hour`) }}</span>
                                <span
                                    class="form__error form__text_error"
                                    v-if="errors.first(`${days[index]}-end-minute`)"
                                >{{ errors.first(`${days[index]}-end-minute`) }}</span>
                            </div>
                        </div>
                    </template>
                </td>
            </tr>
        </table>
        <template v-if="$slots.default">
            <div class="form__hours_hint">
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>

export default {
  name: 'form-hours',
  data () {
    return {
      days: [
        this.$t('forms.date.days.monday'),
        this.$t('forms.date.days.tuesday'),
        this.$t('forms.date.days.wednesday'),
        this.$t('forms.date.days.thursday'),
        this.$t('forms.date.days.friday'),
        this.$t('forms.date.days.saturday'),
        this.$t('forms.date.days.sunday')
      ]
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    hours: {
      type: [Array, Object],
      required: true
    }
  },
  methods: {
    toggleDay: function (key) {
      this.$emit('emit-update', key)
    },
    timeFormat: function (value) {
      if (value.toString().length === 1) {
        value = '0' + value.toString()
      }
      return value
    },
    timeHour: function (value) {
      return value.substring(0, value.indexOf(':'))
    },
    timeMinute: function (value) {
      return value.substring(value.indexOf(':') + 1)
    },
    updateWorkFrom: function (hour, minute, key) {
      this.$store.dispatch('setTrainerWorkingHoursWorkFrom', {
        value: `${hour}:${minute}`,
        key: key
      })
    },
    updateWorkTo: function (hour, minute, key) {
      this.$store.dispatch('setTrainerWorkingHoursWorkTo', {
        value: `${hour}:${minute}`,
        key: key
      })
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formhours";
</style>
